<template>
  <v-container class="fill-height align-center">
    <v-row justify="center">
      <v-card outlined max-width="500">
        <v-card-title>会員ログイン</v-card-title>
        <v-card-text height="400">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field label="ログインID" v-model="loginId" />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="パスワード"
                  v-model="password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-alert
            v-if="error"
            color="red"
            type="error"
          >{{ error }}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="login">ログイン</v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
    <v-row justify="center">
      <v-btn outlined color="primary" class="ma-5" @click="$router.push('/registration')">
        <v-icon left>mdi-text-box-check-outline</v-icon>
        会員登録はこちら
      </v-btn>
      <v-btn text color="primary" class="ma-5" @click="$router.push('/password-reset')">
        パスワードをお忘れの場合はこちら
      </v-btn>
    </v-row>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>お知らせ</v-card-title>
        <v-card-text>
          <p>前回のご利用から180日が経過しています。</p>
          <p>再度ご利用いただくために
          ”パスワードをお忘れの場合はこちら”
          よりパスワードを再設定してください。</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="closeDialog">パスワードの再設定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  name: 'Login',

  data: () => ({
    loginId: '',
    password: '',
    showPassword: false,
    error: '',
    dialog: false
  }),
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$router.push('/password-reset');
    },
    login() {
      const reqData = { login_id: this.loginId, password: this.password };
      this.$store.dispatch('login', reqData)
        .then(() => {
          this.error = '';
          this.$router.push(this.$store.state.afterLoginPath);
        })
        .catch((err) => {
          if (err.response.status === 403) {
            this.error = 'login error: ログインID、パスワードをご確認ください。';
          } else if (err.response.data.error === '180d') {
            this.dialog = true;
          } else {
            this.error = 'Server error.';
          }
        });
    }
  }
};
</script>
